import React from "react";
import { useTranslation } from "react-i18next";

import { LanguageSelector } from "./LanguageSelector";
import PitchlerLogo from "./PitchlerLogo";
import FormTextSmall from "./forms/FormTextSmall";
import { Link, useNavigate } from "react-router-dom";

const Footer: React.FC = () => {
  const { t } = useTranslation(["Footer", "common"]);
  return (
    <footer className="w-full bg-white" aria-labelledby="footer-heading">
      <div className="py-8 mt-16 border-t border-gray-900/10 md:flex md:items-center md:justify-between">
        <div className="flex flex-col justify-between w-full px-4 md:px-8 md:flex-row items-center gap-y-6 gap-x-6">
          <div className="flex flex-col items-center md:flex-row gap-y-4 gap-x-6">
            <PitchlerLogo />
            <p className="text-xs text-gray-500 text-center md:text-left">
              {t("Footer:toolFromPitchler")}
              <br />
              {t("copyright")}
            </p>
          </div>
          <div className="flex flex-col md:flex-row gap-x-4 items-center gap-y-6 flex-shrink-0">
            <div className="flex gap-4">
              <Link
                to={process.env.REACT_APP_PITCHLER_ATS_URL || "/"}
                target="_blank"
                className="underline hover:no-underline hover:opacity-80"
              >
                <FormTextSmall bold text={t("Footer:loginRecruiters")} />
              </Link>
              <Link
                to={"/privacy-policy"}
                className="underline hover:no-underline hover:opacity-80"
              >
                <FormTextSmall bold text={t("common:privacyPolicy")} />
              </Link>
            </div>
            <LanguageSelector />
            {/* No cookies policy needed yet, uncomment when needed */}
            {/* 
              <Link to={"/cookie-policy"} className="hover:underline">
                <FormTextSmall bold text={t("common:cookiePolicy")} />
              </Link>
              */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
